export function Spinner({ size = 20 }: { size?: number }) {
  return (
    <span
      className="inline-block animate-spin border-2 border-line border-t-accent rounded-full"
      style={{ width: size, height: size }}
    />
  );
}
